import React from "react";
import { Box, Typography, useTheme } from "@mui/material";

interface AlertGroupCardProps {
  title: string;
  children: React.ReactNode;
}

/**
 * One group on Manage alerts, in the settings card the page's Notifications
 * card and Account settings use, so every section shares one edge. Rows keep
 * their own side padding; the negative margin lines their content up with the
 * title.
 */
const AlertGroupCard = ({ title, children }: AlertGroupCardProps) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  return (
    <Box
      component="section"
      aria-label={title}
      sx={{
        backgroundColor: isDark ? "rgba(255, 255, 255, 0.02)" : "rgba(255, 255, 255, 0.9)",
        border: `1px solid ${isDark ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.1)"}`,
        borderRadius: 3,
        px: 3,
        pt: 3,
        pb: 2,
        mb: 3,
      }}
    >
      <Typography component="h2" variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
        {title}
      </Typography>
      <Box
        sx={{
          mx: -1.5,
          "& > :not(:first-of-type)": {
            borderTop: `1px solid ${isDark ? "rgba(255, 255, 255, 0.07)" : "rgba(0, 0, 0, 0.07)"}`,
          },
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default AlertGroupCard;
